module.exports = __webpack_public_path__ + "img/shiba-body-level7.4a590db6.png";